import { render, staticRenderFns } from "./ModuleDetailHeader.vue?vue&type=template&id=69cd5952&scoped=true"
import script from "./ModuleDetailHeader.vue?vue&type=script&lang=js"
export * from "./ModuleDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetailHeader.vue?vue&type=style&index=0&id=69cd5952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd5952",
  null
  
)

export default component.exports